import React from 'react'
import { useParams } from 'react-router-dom'

import styles from './styles.module.scss'

import MainLayout from '../../components/Core/MainLayout'
import Invoices from '../../components/Invoices/Invoices'
import ViewInvoice from '../../components/Invoices/View'
import CreateInvoiceV2 from '../../components/Invoices/CreateInvoiceV2'

import { useQuery } from '../../hooks/useQuery'

const InvoicesScreen = () => {
  const { id: companyId } = useParams()
  const { tab: activeTab } = useQuery(['tab:invoices'])

  return (
    <MainLayout layoutClassName={styles.layout} screenClassName={styles.screen}>
      <div className={styles.content}>
        {
          (tab => {
            switch (true) {
              case tab === 'invoices':
                return (
                  <Invoices
                    companyId={companyId} />
                )
              case tab === 'new_invoice':
              case /^\d+$/.test(String(tab)):
                return (
                  <CreateInvoiceV2
                    companyId={companyId} />
                )
              case tab === 'view':
                return (
                  <ViewInvoice
                    companyId={companyId} />
                )
              
            }
          })(activeTab)
        }
      </div>
    </MainLayout>
  )
}

export default InvoicesScreen